<template>
    <div class="container-fluid p-0">
        <!-- Top Language Selector -->
        <login-language-selector 
            v-if="languages && languages.length > 1"
            :languages="languages"
            :current-language="currentLanguage"
        />
        
        <div class="row">
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-8">
            <div class="back-image"
                 :style="'background-image: url('+urlGenerator(configData?.company_banner || '/images/readykit-banner.png')+')'">
            </div>
        </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 pl-md-0">
                <div class="login-form d-flex align-items-center">
                    <form class="sign-in-sign-up-form w-100"
                          ref="form" data-url="/vendor/login" action="store">

                        <div class="text-center mb-4">
                            <img :src="urlGenerator(logoPath)" alt=""
                                 class="img-fluid logo">
                        </div>
                       
                        <div class="form-row">
                            <div class="form-group col-12 px-0">
                                <label for="login_email">{{ $t('email') }}</label>
                                <app-input type="email"
                                           v-model="login.email"
                                           :placeholder="$t('enter_your_email')"
                                           :required="true"/>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 px-0">
                                <label for="login_password">{{ $t('password') }}</label>
                                <app-input type="password"
                                           v-model="login.password"
                                           :show-password="true"
                                           :placeholder="$t('enter_your_password')"
                                           :required="true"/>
                            </div>
                        </div>
                        <div class="form-row" v-if="recaptchaEnable == 1">
                            <div class="form-group col-12 px-0">
                                <re-captcha :site-key="siteKey"></re-captcha>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 px-0">
                                <app-load-more :preloader="preloader"
                                               :label="$t('login')"
                                               type="submit"
                                               class-name="btn btn-primary btn-block text-center"
                                               @submit="submit"/>
                            </div>
                        </div>
                        <!-- <div
                            class="form-row form-row flex-column flex-md-row justify-content-center justify-content-md-between justify-content-lg-between">
                            <a :href="urlGenerator('/forget-password')"
                               class="bluish-text d-flex align-items-center justify-content-center justify-content-lg-end">
                                <app-icon name="lock" class="pr-2"/> {{ $t('forgot_password') }}
                            </a>
                            <a v-if="configData?.registration === 'on'" :href="urlGenerator('/user/register')"
                               class="bluish-text d-flex align-items-center justify-content-center justify-content-lg-end">
                                <app-icon name="user" class="pr-2"/> {{ $t('register') }}
                            </a>
                        </div> -->
                        <div class="form-row">
                            <div class="col-12">
                                <p class="text-center mt-5">
                                    {{ $t('copyright_text') + (configData?.company_name || 'RawafedDash') }}
                                </p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ThemeMixin from "../../../../core/mixins/global/ThemeMixin";
    import {AuthMixin} from "./Mixins/AuthMixin";
    import {urlGenerator} from "../../../Helpers/AxiosHelper";
    import LoginLanguageSelector from "./LoginLanguageSelector.vue";

    export default {
        name: "Login",
        mixins: [AuthMixin, ThemeMixin],
        components: {
            LoginLanguageSelector
        },
        props: {
            siteKey: String,
            recaptchaEnable: {},
            languages: {
                type: Array,
                default: () => []
            },
            configData: {
                type: Object,
                default: () => ({
                    company_name: 'RawafedDash',
                    company_logo: '/images/logo.png',
                    company_banner: '/images/readykit-banner.png',
                    company_icon: '/images/icon.png',
                    registration: 'off'
                })
            }
        },
        data() {
            return {
                urlGenerator,
                login: {email: '', password: ''},
            };
        },
        computed: {
            currentLanguage() {
                return this.$i18n.locale();
            },
            logoPath() {
                const baseLogo = '/images/logo.svg';
                const currentLocale = this.$i18n.locale();
                
             
                
                // If language is English, append '_en' to the logo path
                if (currentLocale === 'en') {
                    // Extract file extension and name
                    const lastDotIndex = baseLogo.lastIndexOf('.');
                    if (lastDotIndex !== -1) {
                        const nameWithoutExt = baseLogo.substring(0, lastDotIndex);
                        const extension = baseLogo.substring(lastDotIndex);
                        return `${nameWithoutExt}_en${extension}`;
                    }
                    return `${baseLogo}_en`;
                }
                
                return baseLogo;
            }
        },
        methods: {
            submit() {
                this.save(this.login);
            },
            async afterSuccess(res) {
                console.log('=== LOGIN RESPONSE DEBUG ===');
                console.log('Full response:', res);
                console.log('Response data:', res.data);
                console.log('Response data type:', typeof res.data);
                
                // Initialize FCM after successful login
                try {
                    const FcmService = (await import('../../../Services/FcmService.js')).default;
                    const initialized = await FcmService.initialize();
                    if (initialized) {
                        // Register token with API
                        await FcmService.registerToken();
                        console.log('FCM: Token registered after login');
                    }
                } catch (error) {
                    console.warn('FCM: Failed to initialize after login:', error);
                    // Don't block login if FCM fails
                }
                
                // Handle string response (URL directly)
                let redirectUrl = res.data;
                
                // Ensure it's a string
                if (typeof redirectUrl !== 'string') {
                    console.error('Expected string URL but got:', typeof redirectUrl, redirectUrl);
                    redirectUrl = '/admin/dashboard';
                }
                
                console.log('Final redirect URL:', redirectUrl);
                console.log('=== END DEBUG ===');
                
                window.location = redirectUrl;
            }
        }
    }
</script>
